module.exports = __webpack_public_path__ + "img/icons-fill-invoice-saphhire.9eb44b40.svg";